import React from 'react';
import { CharacterStats, StatType } from '../../../../../shared/CharacterTypes';
import { getStatAbbreviation, getStatDescription } from './StatHelpers';
import { TomeChapter } from '../../../primitives/tome';
import { StatLedgerRow } from './StatLedgerRow';

interface CombatStatsPanelProps {
  stats: CharacterStats;
  characterClass?: string;
}

const COMBAT_STATS = [
  { stat: StatType.ATTACK, label: 'Physical Attack' },
  { stat: StatType.MAGIC_ATTACK, label: 'Magic Attack' },
  { stat: StatType.DEFENSE, label: 'Physical Defense' },
  { stat: StatType.MAGIC_DEFENSE, label: 'Magic Defense' },
  // Schema floats arrive as Float32 (2.2 → 2.200000047683716) — round for display.
  { stat: StatType.CRITICAL_RATE, label: 'Critical Rate', format: (value: number) => `${Number(value.toFixed(2))}%` },
  { stat: StatType.CRITICAL_DAMAGE, label: 'Critical Damage', format: (value: number) => `${Number(value.toFixed(2))}×` },
] as const;

export const CombatStatsPanel: React.FC<CombatStatsPanelProps> = ({ stats, characterClass }) => (
  <TomeChapter className="character-stat-section" title="Combat">
    <p className="character-stat-section__intro">Current synced offensive and defensive values.</p>
    <div className="character-stat-list" role="list">
      {COMBAT_STATS.map(({ stat, label, ...entry }) => (
        <StatLedgerRow
          key={stat}
          statType={stat}
          stats={stats}
          characterClass={characterClass}
          abbreviation={getStatAbbreviation(stat)}
          label={label}
          value={stats[stat]}
          description={getStatDescription(stat)}
          formatValue={'format' in entry ? entry.format : undefined}
        />
      ))}
    </div>
  </TomeChapter>
);
